import axios from "axios";
axios.defaults.timeout = 5000;
import { Toast } from "vant";
axios.defaults.headers.post["Content-Type"] = "application/json;charset=UTF-8";
export default {
  fetchGet (url, params = {}) {
    Toast.loading({
      mask: true,
      message: "加载中..."
    });
    const headers = JSON.parse(localStorage.getItem("headers"));
    return new Promise((resolve, reject) => {
      axios({
        url: url, //仅为示例，并非真实的接口地址
        method: "get",
        data: params,
        headers
      })
        .then(res => {
          if (res.data.responseCode === "1") {
            Toast.clear();
            resolve(res.data);
          } else if (res.data.responseCode === "5") {
            Toast.clear();
            reject(res.data);
          } else {
            // Toast.fail("无匹配数据");
            Toast.fail(res.data.responseMessage);
            reject(res.data);
          }
        })
        .catch(error => {
          Toast.clear();
          reject(error);
        });
    });
  },
  fetchPost (url, params = {}) {
    Toast.loading({
      mask: true,
      message: "加载中..."
    });
    return new Promise((resolve, reject) => {
      const headers = JSON.parse(localStorage.getItem("headers"));
      // headers['x-auth-mortgage-transfer'] = 'largecustomer_dev--item--487--item--9999--item--111111'
      axios({
        url: url, //仅为示例，并非真实的接口地址
        method: "post",
        data: params,
        headers
      })
        .then(res => {
          if (res.data.responseCode === "1") {
            Toast.clear();
            resolve(res.data);
          } else if (res.data.responseCode === "5") {
            Toast.clear();
            reject(res.data);
          } else {
            if (res.data.responseMessage !== "该手机号无可查询流程") {
              Toast.fail(res.data.responseMessage);
            }
            reject(res.data);
          }
        })
        .catch(error => {
          Toast.clear();
          reject(error);
        });
    });
  }
};
